import { State } from '../state';

export const isLoggedIn = (state: State) => Boolean(state.token);

export const hasJoined =  (state: State) => Boolean(state.competitionUser);

export const isImpersonating = (state: State) => Boolean(state.initialQuery.impersonate_token);
